import { useBadgingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import FlipOutlinedIcon from '@mui/icons-material/FlipOutlined';
import { Box, Button, CircularProgress, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { BadgePreviewContextProvider } from '../contexts/BadgePreviewContext';
import { BadgeTemplatePreview } from './BadgeTemplatePreview';
export const BadgePreviewModal = ({ ariaTitleId, ariaContentId, badgeTemplateData, badgePreviewContext, close, }) => {
    const { t } = useBadgingTranslation();
    const [isBackTemplateVisible, setIsBackTemplateVisible] = React.useState(false);
    const handleFlipTemplate = () => {
        setIsBackTemplateVisible((prevState) => !prevState);
    };
    return (React.createElement(BadgePreviewContextProvider, Object.assign({}, badgePreviewContext),
        React.createElement(DialogTitle, { id: ariaTitleId }, t('badgePreview.previewModalTitle', {
            title: badgeTemplateData === null || badgeTemplateData === void 0 ? void 0 : badgeTemplateData.data.title,
        })),
        React.createElement(DialogContent, { sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }, id: ariaContentId }, badgeTemplateData ? (React.createElement(Box, { sx: {
                px: 5,
                py: 2,
                borderRadius: 1,
                backgroundColor: themeColors.surface.secondary,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
            } },
            React.createElement(BadgeTemplatePreview, { badgeTemplateClassifier: badgeTemplateData, badgeTemplate: isBackTemplateVisible ? badgeTemplateData.data.badgeTemplateBack : badgeTemplateData.data.badgeTemplateFront, formSettings: badgeTemplateData.data.defaultFormSettings, account: badgeTemplateData.data.defaultSampleAccountData, sx: {
                    borderStyle: 'solid',
                    borderWidth: 2,
                    borderColor: themeColors.border.main,
                    borderRadius: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'start',
                } }),
            React.createElement(Button, { startIcon: React.createElement(FlipOutlinedIcon, null), onClick: handleFlipTemplate }, t('badgePreview.flipBadge')))) : (React.createElement(CircularProgress, null))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { variant: 'text', color: 'primary', onClick: () => close() }, t('badges.badgeCard.close')))));
};
